import { FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { of, Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { removeWhiteSpaces } from './util-functions';
import { CreditCard } from 'angular-cc-library';

export function emailValidator(control: FormControl): {[key: string]: any} {
    var emailRegexp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
    if (control.value && !emailRegexp.test(control.value)) {
        return {invalidEmail: true};
    }
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
        let password= group.controls[passwordKey];
        let passwordConfirmation= group.controls[passwordConfirmationKey];
        if (password.value !== passwordConfirmation.value) {
            return passwordConfirmation.setErrors({mismatchedPasswords: true})
        }
    }
}

/*********First Name or Last Name validations**********/
export function firstLastName(control: FormControl): any {
    let firstChar = control.value.charCodeAt(0);
    let charArray = control.value.split('');
    let res = charArray.map(v => {
        let char = v.charCodeAt(0);
        return (firstCharacter(firstChar) && nextCharacter(char)) ? true : false;
    })
    if(res.includes(false)) {
        return {firstLastName: true}
    }
}

const firstCharacter = (code) => (code > 64 && code < 91) || (code > 96 && code < 123);
const nextCharacter = (code) => ((code > 64 && code < 91) || (code > 96 && code < 123) || code === 32 || code === 46 || code === 39 || code === 92 || code === 45);
/**********************End*********************/

/*********Check already account is exist or not**********/
export function checkAccountExist(apiService: ApiService, userDetails: object, field: string): any {
    return (control: AbstractControl): Promise<any | null> | Observable<any | null> => {
        let fieldValue = control.value;
        if(field === "phone_number") {
            fieldValue = fieldValue.replace(/[^0-9]+/g, '');
        }
        if(field === "email_id") {
            fieldValue = fieldValue.toLowerCase();
        }
        if(userDetails[field] != fieldValue) {
            let fieldAndValue = [];
            fieldAndValue[field] = fieldValue;
            let params = {
                ...fieldAndValue,
                // website_check: "global"
            }
            return apiService.checkCustomerIsAlreadyExist(params).pipe(
                map(data => {
                    if(data['response']['status'] === 3) {
                        return {
                            validation: true,
                            message: data['response']['data']['message'][field]
                        };
                    }else if(data['response']['status'] === 4) {
                        return {exist: true};
                    }else {
                        return null;
                    }
                }, err =>  console.log(err))
            )
        }else {
            return of(null);
        }
    }
}
/**********************End*********************/

/*********Check zipcode is exist or not**********/
export function checkZipcode(apiService: ApiService, userDetails: object): any {
    return (control: AbstractControl): Promise<any | null> | Observable<any | null> => {
        if(userDetails["zipcode"] != control.value) {
            let params = {
                website_check: "global",
	            zipcode: control.value
            };
            return apiService.checkZipcode(params).pipe(
                map(data => {
                    if(data['response']['status'] === 2) {
                        return {required: true};
                    }else if(data['response']['status'] === 3) {
                        // return {zipcodeError: true, message: "Invalid zip code"};
                        return {
                            validation: true,
                            message: data['response']['data']['message']['zipcode']
                        };
                    }else if(data['response']['status'] === 6) {
                        return {zipcodeError: true, message: "We do not serve in this area at the moment. We will contact you to discuss"};
                    }else {
                        return null;
                    }
                }, err =>  console.log(err))
            )
        }else {
            return of(null);
        }
    }
}
/**********************End*********************/

/**********Check Credit Card ExpDate***********/
export function checkExpiryDate(control: FormControl): {[key: string]: any} {
    let value = control.value.replace(/[^0-9]/g,'');
    if(value.length === 4) {
        let expiryDate = null;
        value = value.toString();
        let currentDate = moment();
        if(value.length === 4) {
            expiryDate = moment(`${value.slice(0, 2)}-${value.slice(-2)}`, 'MM-YY');
        }
        // else if(value.length === 6) {
        //     expiryDate = moment(`${value.slice(0, 2)}-${value.slice(-4)}`, 'MM-YYYY');
        // }
        let expMonth = parseInt(expiryDate.format('MM'));
        let expYear = parseInt(expiryDate.format('YYYY'));
        let curMonth = parseInt(currentDate.format('MM'));
        let curYear = parseInt(currentDate.format('YYYY'));
        if(curYear > expYear || curYear === expYear && curMonth >= expMonth) {
            return {expDate: true}
        }
    }else if(value.length >= 5) {
        return {maxlength: true}
    }else {
        return {expDate: true}
    }
}
/**********************End*********************/

/**********Check Credit CSV Code***********/
export function checkCSVCode(cvvKey: string, ccNumberKey: string) {
    return (group: FormGroup) => {
        let cvv= group.controls[cvvKey];
        let ccNumber= group.controls[ccNumberKey];
        let cvv_value= removeWhiteSpaces(cvv.value);
        let ccNumber_value= removeWhiteSpaces(ccNumber.value);
        if(ccNumber.valid && cvv_value.length >= 3) {
            let ccType = CreditCard.cardType(ccNumber_value);
            cvv_value = cvv_value.length > 4 ? cvv_value.slice(0,4) : cvv_value;
            if(ccType === "amex" && cvv_value.length !== 4) {
                return cvv.setErrors({invalid: true})
            }else if(ccType !== "amex" && cvv_value.length !== 3) {
                return cvv.setErrors({invalid: true})
            }
        }else{
            return cvv.setErrors({invalid: true})
        }
    }
}
/**********************End*********************/

export class EmailMatchValidation {
    static MatchPassword(AC: AbstractControl) {
        let email = AC.get('email_id').value.toLowerCase();
        if(AC.get('verify_email_id').touched || AC.get('verify_email_id').dirty) {
            let verifyEmail = AC.get('verify_email_id').value.toLowerCase();

            if(email != verifyEmail) {
                AC.get('verify_email_id').setErrors( {emailMismatch: true} )
            } else {
                AC.get('verify_email_id').setErrors(null);

                return null
            }
        }
    }
}

export function numberValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isValid = /^[0-9\(\)\-\+\s]*$/.test(control.value);
      return isValid ? null : { 'numberOnly': { value: control.value } };
    };
  }
  